import firestoreServices from '../services/firestore.service';

const usersFirestoreServices = firestoreServices('roles');

export default {
  ...usersFirestoreServices
};
